import { instance as axios, setJwtToken } from "../../config/AxiosInstance";

// ---------------------Google Meet Api--------------------------------
export const fetchMeetAuthApi = async () => {
  const endPoint = `user/live/google-meet-auth`;
  return await axios.get(endPoint, setJwtToken());
};

// Disconnect Google Meet Api
export const disconnectMeetApi = async (data) => {
  const endPoint = `user/live/google-meet-auth?_id=${data}`;
  return await axios.delete(endPoint, setJwtToken());
};

// ---------------------Verify Google Meet Code --------------------------------
export const verifyGoogleMeetCode = async (data) => {
  const endPoint = `user/live/google-meet-auth-verification?code=${data}`;
  return await axios.get(endPoint, setJwtToken());
};

// Live List
export const liveListApi = async (data) => {
  const endPoint =
    `user/live/list` +
    "?" +
    new URLSearchParams({
      ...data,
      pagination: true,
      page: 1,
      limit: 10,
    }).toString();
  return await axios.get(endPoint, setJwtToken());
};

// Add Live Event
export const addLiveEventApi = async (data) => {
  return await axios.post(`/user/live`, data, setJwtToken());
};

//Upldate Live Event
export const updateLiveEventApi = async (data) => {
  return await axios.put(`/user/live`, data, setJwtToken());
};
// ----------------google-Meet-Connect-Api---------------
export const googleMeetConnectApi = async () => {
  const endPoint = `user/live/google-meet-auth`;
  return await axios.get(endPoint, setJwtToken());
};
